/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react-refresh/only-export-components */
import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

import {
  BaseModal,
  type BaseModalDispatch,
  BaseModalProvider,
  type BaseModalState,
  useBaseModalDispatch,
  useBaseModalState,
} from './BaseModal'

interface AlreadyReportedUrlState extends BaseModalState {}

interface AlreadyReportedUrlDispatch extends BaseModalDispatch {}

const AlreadyReportedUrlStateContext = createContext<AlreadyReportedUrlState>(
  {} as AlreadyReportedUrlState,
)
AlreadyReportedUrlStateContext.displayName = 'AlreadyReportedUrlState'

const AlreadyReportedUrlDispatchContext =
  createContext<AlreadyReportedUrlDispatch>({} as AlreadyReportedUrlDispatch)
AlreadyReportedUrlDispatchContext.displayName = 'AlreadyReportedUrlDispatch'

function AlreadyReportedUrlProvider({
  children,
  modalContent,
}: PropsWithChildren & { modalContent?: JSX.Element }): JSX.Element {
  return (
    <BaseModalProvider>
      <AlreadyReportedUrlProviderInner modalContent={modalContent}>
        {children}
      </AlreadyReportedUrlProviderInner>
    </BaseModalProvider>
  )
}

function AlreadyReportedUrlProviderInner({
  children,
  modalContent,
}: PropsWithChildren & { modalContent?: JSX.Element }): JSX.Element {
  const baseState = useBaseModalState()
  const baseDispatch = useBaseModalDispatch()

  return (
    <AlreadyReportedUrlStateContext.Provider value={baseState}>
      <AlreadyReportedUrlDispatchContext.Provider value={baseDispatch}>
        <BaseModal isOpen={baseState.isOpen} close={baseDispatch.close}>
          {modalContent}
        </BaseModal>
        {children}
      </AlreadyReportedUrlDispatchContext.Provider>
    </AlreadyReportedUrlStateContext.Provider>
  )
}

function useAlreadyReportedUrlState(): AlreadyReportedUrlState {
  try {
    const context = useContext(AlreadyReportedUrlStateContext)
    return context
  } catch (error) {
    throw new Error(
      'useAlreadyReportedUrlState must be used within a AlreadyReportedUrlProvider',
    )
  }
}

function useAlreadyReportedUrlDispatch(): AlreadyReportedUrlDispatch {
  try {
    const context = useContext(AlreadyReportedUrlDispatchContext)
    return context
  } catch (error) {
    throw new Error(
      'useAlreadyReportedUrlDispatch must be used within a AlreadyReportedUrlProvider',
    )
  }
}

export {
  AlreadyReportedUrlProvider,
  useAlreadyReportedUrlState,
  useAlreadyReportedUrlDispatch,
}
